import styled from 'styled-components';

export const ConfirmationErrorStyle = styled.div`
  .go-back {
    width: 56px;
    display: flex;
  }
`;
